import { useTranslation } from 'react-i18next';
import AuditDrawerFrame from 'components/admin/audit/AuditDrawerFrame';
import AuditTimeline from 'components/admin/audit/AuditTimeline';
import type { AdminAuditEvent } from 'api/adminAuditApi';

interface EventDrawerProps {
  /** The row's own event, already loaded by the table — this drawer never fetches. */
  event: AdminAuditEvent | null;
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

/** Detail panel for ONE already-loaded event (J13). Its own frame (`AuditDrawerFrame`, C1), but the
 * body renders through `AuditTimeline` (`events={[event]}`) rather than a second row implementation. */
const EventDrawer = ({ event, open, onOpenChange }: EventDrawerProps) => {
  const { t } = useTranslation();
  if (!event) return null;

  return (
    <AuditDrawerFrame open={open} onOpenChange={onOpenChange} title={t('Details')} description={event.entityLabel ?? event.entityId}>
      <AuditTimeline events={[event]} retentionMonths={null} isLoading={false} isError={false} />
    </AuditDrawerFrame>
  );
};

export default EventDrawer;
